<template>
  <div>
    <el-form
      :rules="rules"
      :model="selectedDistrict"
      ref="formedForm"
      label-position="top"
      label-width="120px"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="" label="Полное наименование участка">
            <el-row
              :key="key"
              v-for="(objName, key) in selectedDistrict.listName"
            >
              <el-col :span="7">
                <el-input v-model="objName.name"></el-input>
              </el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="objName.dateFrom"
                  type="date"
                  placeholder="Дата старта наименования"
                  value-format="yyyy-MM-dd"
                  format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-col>
              <el-col :span="7">
                <el-date-picker
                  v-model="objName.dateTo"
                  type="date"
                  placeholder="Дата конца наименования"
                  value-format="yyyy-MM-dd"
                  format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-col>
              <el-col :span="3">
                <el-button
                  @click="deleteLine(key)"
                  type="primary"
                  style="float: left"
                  >Удалить</el-button
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-button @click="addLine" type="primary" style="float: left"
                  >Добавить</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            prop="parentInfo"
            label="Объект / Филиал / Название подразделения"
          >
            <el-select
              style="width: 100%"
              clearable
              value-key="id"
              v-model="selectedDistrict.parentInfo"
              filterable
              placeholder="Выберите"
            >
              <el-option
                v-for="item in organizationHierarchyByType"
                :key="item.id"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-date-picker
          v-model="selectedDistrict.dateFrom"
          type="date"
          placeholder="Дата начала работы"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-row>
      <br />
      <el-row>
        <input type="checkbox" id="checkbox" v-model="selectedDistrict.datEd" />
        <label for="checkbox">Устаревшее</label>
      </el-row>
      <el-row>
        <el-date-picker
          v-model="selectedDistrict.dateTo"
          type="date"
          :disabled="!selectedDistrict.datEd"
          placeholder="Выберите дату"
          value-format="yyyy-MM-dd"
          format="dd.MM.yyyy"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-button @click="addDist" type="primary">Сохранить</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "districtsEdit",
  props: ["selectedDistrict"],
  data() {
    return {
      pickerOptions:{
        firstDayOfWeek: 1
      },
      editDistrictForm: {},
      rules: {
        parentInfo: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],

        title: [
          {
            required: true,
            message: "Заполните поле",
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters({
      organizationHierarchyByType: "GETORGANIZATIHIERARCHYBYTYPE",
    }),
  },

  methods: {
    deleteLine(index) {
      this.selectedDistrict.listName.splice(index, 1);
    },
    addLine() {
      console.log(this);
      this.selectedDistrict.listName.push({
        name: "",
        datEd: null,
        dateTo: null,
      });
    },
    addDist() {
      this.$refs["formedForm"].validate((valid) => {
        if (valid) {
          this.selectedDistrict.title =
            this.selectedDistrict.listName[
              this.selectedDistrict.listName.length - 1
            ].name;
          this.$store
            .dispatch("updateOrganizationUnitInfo", this.selectedDistrict)
            .then(() => {
              this.notification("Успешно", "Участок добавлен", "success");
              this.$store.dispatch("getListUnits", 3);
              this.$store.dispatch("setShowModal", null);
            });
        }
      });
    },

    getOrganizationHierarchyByType() {
      this.$store.dispatch("getOrganizationHierarchyByType", {
        type: 2,
      });
    },
  },

  mounted() {
    this.getOrganizationHierarchyByType();
  },
};
</script>

<style scoped></style>
